// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-header {
  display: flex;
  align-items: center;
}

.tab-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.tab-text {
  font-size: 16px;
}


#upl{
 text-align: center;
}
.summaryborders {
  border: 1px solid #fff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgb(2 14 21 / 20%), 0 10px 20px rgb(22 2 2 / 15%);
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/BulkQuotes/Bulk.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;;AAGA;CACC,kBAAkB;AACnB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wEAAwE;AAC1E","sourcesContent":[".tab-header {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.tab-image {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.tab-text {\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n#upl{\r\n text-align: center;\r\n}\r\n.summaryborders {\r\n  border: 1px solid #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 5px 15px rgb(2 14 21 / 20%), 0 10px 20px rgb(22 2 2 / 15%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
